var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoExceptionCompanies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "28px",
    viewBox: "0 0 31 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 22") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-1141.000000, -789.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(1141.000000, 790.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "comp-copy-4",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "26 13.4101562 26 0.0544433594 9.01660156 0.0544433594 9.01660156 23.9993896 18.7980957 23.9993896"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 1,
    y: 8,
    width: 8,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,4.5 L21.5,4.5",
    id: "Path-38",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,8.5 L21.5,8.5",
    id: "Path-38",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5,12.5 L21.5140381,12.5",
    id: "Path-38",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.5937277,26.544973 L24.5937277,26.6298774 C24.5780777,26.6157274 24.5624564,26.60159 24.5468639,26.5874654 C24.5312713,26.60159 24.51565,26.6157274 24.5,26.6298774 L24.5,26.544973 C18.923759,21.4840718 17.0492399,18.0578241 18.8764426,16.26623 C20.6993015,14.4788949 22.5894419,14.5837319 24.5468639,16.580741 C26.5042858,14.5837319 28.3944262,14.4788949 30.2172852,16.26623 C32.0444878,18.0578241 30.1699687,21.4840718 24.5937277,26.544973 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoExceptionCompanies);
export default __webpack_public_path__ + "static/media/ico_exception-companies.286599d39af658b3c0ff2bdc405e2dff.svg";
export { ForwardRef as ReactComponent };